__turbopack_context__.v({
  "affiliations": "DisclosureBlock-module-scss-module__7gpW2a__affiliations",
  "affiliations-logos": "DisclosureBlock-module-scss-module__7gpW2a__affiliations-logos",
  "credit-card-logos": "DisclosureBlock-module-scss-module__7gpW2a__credit-card-logos",
  "disclosures": "DisclosureBlock-module-scss-module__7gpW2a__disclosures",
});
